import { pendingTask, begin, end } from "react-redux-spinner";
import { put } from "redux-saga/effects";

import UserFeedback from "../user.feedback";
import UserService from "../user.service";
import {
  getDevicesResponse,
  IRemoveDevice,
  userUpdateResponse
} from "../user.actions";

export function* getDevices() {
  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const service = new UserService();
    const devices = yield service.getDevices();
    yield put(getDevicesResponse(devices));
  } catch (error) {
    yield put(getDevicesResponse(error, UserFeedback.DEVICES_GET_FAILED));
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* removeDeviceSaga(action: IRemoveDevice) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const { userId, deviceId } = action.payload;
    const userService = new UserService();
    const user = yield userService.removeDevice(userId, deviceId);
    yield put(userUpdateResponse(user, UserFeedback.DEVICE_REMOVED));
  } catch (error) {
    yield put(userUpdateResponse(error, UserFeedback.DEVICE_REMOVE_FAILED));
  }
  yield put({ type: "SPINNER", [pendingTask]: end });
}
